import {
  ChangeDetectorRef,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/models/model.model';
import { Plant } from 'src/app/models/plant.model';
import { RefPointDateTime, Train, TrainViewmodel } from 'src/app/models/train.model';
import { Unit } from 'src/app/models/unit.interface';
import { Stage } from 'src/app/models/stage.interface';
import { Hybrid } from 'src/app/models/hybrid.interface';
import { User, UserList } from 'src/app/models/user.model';
import { ModelsService } from 'src/app/services/models/models.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { TrainUsers } from 'src/app/models/trainusers.model';
import { userAccessOption } from 'src/app/models/userAccessOption.interface';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import {
  RawCalcTrainDataViewModel,
  RefPointRawCalcTrainDataViewModel,
} from 'src/app/models/OpRawCalc.model';
import {
  PagingHeader,
  QueryStringParameters,
} from 'src/app/shared/shared.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-train',
  templateUrl: './edit-train.component.html',
  styleUrls: ['./edit-train.component.scss'],
})
export class EditTrainComponent {
  // @ViewChild('picker') picker!: MatDatepicker<Date>;
  trainId: number = 0;
  plantName: string = '';
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'Metric' },
    { Id: 1, UnitName: 'English' },
  ];
  public stage: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
  ];
  public hybrid: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  public hybridSt2: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  public hybridSt3: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  queryParams: QueryStringParameters = new QueryStringParameters();
  [x: string]: any;

  trainDetails: Train = new Train();
  trainrefpointdatetime : RefPointDateTime = new RefPointDateTime();
  plants: Plant[] = [];
  users: User[] = [];
  models: Model[] = [];
  showDiv = false;
  showDiv2 = false;
  showHybrid = true;
  showStage1hybrid = false;
  stage2Nhybrid = true;
  showHybrid2 = true;
  showStage2hybrid = false;
  stage3Nhybrid = true;
  showHybrid3 = true;
  showStage3hybrid = false;
  TrainId: number;
  trainIdCal!: number;
  showDuplicate: boolean = false;
  selectedUser: User[] = [];
  ids: string[] = [];
  addTrainUsers: TrainUsers = new TrainUsers();
  comanyUsers: User[] = [];
  opdataList: RefPointRawCalcTrainDataViewModel[] = [];
  trainobj: TrainViewmodel = new TrainViewmodel();
  trainUserId: string = '';
  accessChoice: string;
  DelTrainId: any;
  // RefPointDateTime: string;
   RefPointDateTime: { trainId: number; datetime: string } | null = null;
  elementpervessele = false;
  elementperVesselstage2 = false;
  elementperVesselstage3 = false;
  showRefpointList = false;
  addTrainRequest: Train = new Train();
  @ViewChild('picker') picker!: MatDatepicker<Date>;

  operationForm!: FormGroup;
  //  years: number[] = [];
  // allowedMonths: number[] = [];
  // allowedDays: number[] = [];
  // timeList: string[] = [];

  // loading = false;
  // loadingMsg = '';
  // datepickerLoading = false;
  // noYearMessage = '';
  years: number[] = [];
  allowedMonths: number[] = [];
  allowedDays: number[] = [];
  timeList: string[] = [];

  loading = false;
  loadingMsg = '';
  datepickerLoading = false;
  noYearMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private userService: UserService,
    private modelService: ModelsService,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,
    private opdataservice: OpdataService,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) {}

  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  public useraccessOption: Array<userAccessOption> = [
    { Id: 0, Name: 'Restrict Access For All Except Permitted Users:' },
    { Id: 1, Name: 'Allow Access For All Except Restricted Users:' },
  ];
  onOptionSelected() {
    if (this.trainDetails.Stages != null) {
      let stageStr = this.trainDetails.Stages.toString();
      if (stageStr === '2') {
        this.showDiv = true;
        this.showDiv2 = false;
      } else if (stageStr === '3') {
        this.showDiv = true;
        this.showDiv2 = true;
      } else {
        this.showDiv = false;
        this.showDiv2 = false;
      }
    }
  }
  onOptionHybrid() {
    if (this.trainDetails.Hybrid != null) {
      let stage1Hybrid = this.trainDetails.Hybrid.toString();
      if (stage1Hybrid === '1') {
        this.showStage1hybrid = true;
        this.showHybrid = false;
        this.elementpervessele = true;
      } else {
        this.showStage1hybrid = false;
        this.showHybrid = true;
        this.elementpervessele = false;

        this.trainDetails.Stage1Element1Qty = 0;
        this.trainDetails.Stage1Element2Qty = 0;
        this.trainDetails.Stage1Element3Qty = 0;
      }
    }
  }

  onOptionHybridS2() {
    if (this.trainDetails.Hybrid2 != null) {
      let stage2Hybrid = this.trainDetails.Hybrid2.toString();
      if (stage2Hybrid === '1') {
        this.showStage2hybrid = true;
        this.stage2Nhybrid = false;
        this.elementperVesselstage2 = true;
      } else {
        this.showStage2hybrid = false;
        this.stage2Nhybrid = true;
        this.elementperVesselstage2 = false;

        this.trainDetails.Stage2Element1Qty = 0;
        this.trainDetails.Stage2Element2Qty = 0;
        this.trainDetails.Stage2Element3Qty = 0;
      }
    }
  }

  onOptionHybridS3() {
    if (this.trainDetails.Hybrid3 != null) {
      let stage3Hybrid = this.trainDetails.Hybrid3.toString();
      if (stage3Hybrid === '1') {
        this.showStage3hybrid = true;
        this.stage3Nhybrid = false;
        this.elementperVesselstage3 = true;
      } else {
        this.showStage3hybrid = false;
        this.stage3Nhybrid = true;
        this.elementperVesselstage2 = false;

        this.trainDetails.Stage3Element1Qty = 0;
        this.trainDetails.Stage3Element2Qty = 0;
        this.trainDetails.Stage3Element3Qty = 0;
      }
    }
  }

  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  CurrentUserId = this.loggedInuserRole.userId;
  onAccessOptionSelected(e) {
    console.log(e.target.value);
    this.accessChoice = e.target.value;
    this.selectedUser = [];
  }
  QuantityAdditionStage1() {
    this.trainDetails.Stage1ElementsVessel =
      Number(this.trainDetails.Stage1Element1Qty) +
      Number(this.trainDetails.Stage1Element2Qty) +
      Number(this.trainDetails.Stage1Element3Qty);
  }
  QuantityAdditionStage2() {
    this.trainDetails.Stage2ElementsVessel =
      Number(this.trainDetails.Stage2Element1Qty) +
      Number(this.trainDetails.Stage2Element2Qty) +
      Number(this.trainDetails.Stage2Element3Qty);
  }
  QuantityAdditionStage3() {
    this.trainDetails.Stage3ElementsVessel =
      Number(this.trainDetails.Stage3Element1Qty) +
      Number(this.trainDetails.Stage3Element2Qty) +
      Number(this.trainDetails.Stage3Element3Qty);
  }

  // getOpdataDates(TrainId) {
  //   console.log(TrainId);
  //   this.opdataservice
  //     .getRefPointRawCalcOpdataListByTrainId(TrainId)
  //     .subscribe({
  //       next: (response) => {
  //         this.opdataList = response;
  //         console.log('calcData : ', this.opdataList);
  //         const refPointExists = this.opdataList.some(
  //           (model) => model.Id === this.trainDetails.RefPoint
  //         );
  //         if (this.opdataList.length > 0) {
  //           if (!this.trainDetails.RefPoint || !refPointExists) {
  //             this.trainDetails.RefPoint = this.opdataList[0].Id;
  //           }
  //           this.showRefpointList = true;
  //         }
  //       },
  //     });
  // }
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(
      atob(sessionStorage.getItem('currentUser')!)
    );
    
    this.operationForm = this.fb.group({
      datetime: [null],
      time: [''],
    });
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        // const id = this.route.snapshot.paramMap.get('id')!;
        this.RefPointAndDateTimeByTrainId(Number(id));
        this.trainIdCal = Number(id);

        this.preloadYears(Number(id));
        console.log(id);
        
      },
    });
    if (
      loggedInuserRole.role == 'Admin' ||
      loggedInuserRole.role == 'Internal User'
    ) {
      this.showDuplicate = true;
    }
    this.userService.getAllUser().subscribe({
      next: (users) => {
        this.users = users;
      },
      error: (response) => {
        console.log(response);
      },
    });
    if (loggedInuserRole.role == 'Standard User') {
      this.modelService.getAllModelForNonAdminUser().subscribe({
        next: (models) => {
          this.models = models;
        },
      });
    } else {
      this.modelService.getAllModel().subscribe({
        next: (models) => {
          this.models = models;
        },
      });
    }

    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        console.log(id);
        

        console.log(id);
        if (id) {
          this.trainService.getTrainById(id).subscribe({
            next: (response) => {
              this.trainDetails = response;
              this.plantService.setSelectedPlant(response.PlantId);
              this.plantService.setSelectedTrain(response.Id);

              //below method is for populating datetime stamp for reference point
              // this.getOpdataDates(id);

              console.log(this.trainDetails);
              this.onOptionSelected();
              this.onOptionHybrid();
              this.onOptionHybridS2();
              this.onOptionHybridS3();
              let loggedInuserRole = JSON.parse(
                atob(sessionStorage.getItem('currentUser'))!
              );
              if (loggedInuserRole.role == 'Standard User') {
                this.plantService
                  .getPlantsByUserId(loggedInuserRole.userId)
                  .subscribe({
                    next: (plants) => {
                      this.plants = plants;
                    },
                  });
              } else {
                this.plantService.getAllPlant().subscribe({
                  next: (plants) => {
                    this.plants = plants;
                    this.plantName = this.plants.filter(
                      (x) => x.Id == this.trainDetails.PlantId
                    )[0].Name;
                  },
                  error: (response) => {
                    console.log(response);
                  },
                });
              }
              this.trainService
                .GetUsersByPlantId(this.trainDetails.PlantId)
                .subscribe({
                  next: (comanyUsers) => {
                    this.comanyUsers = comanyUsers;
                    console.log(this.comanyUsers);
                  },
                });
            },
          });
          if (this.trainDetails.AccessOption == 1) {
            this.trainService.getUsersByTrainId(id).subscribe({
              next: (models: User[]) => {
                this.selectedUser = models;
                this.ids = models.map((item) => item.Id);
                console.log(this.selectedUser);
              },
            });
          } else if (this.trainDetails.AccessOption == 0) {
            this.trainService.getAllowedUsersByTrainId(id).subscribe({
              next: (models: User[]) => {
                this.selectedUser = models;
                this.ids = models.map((item) => item.Id);
                console.log(this.selectedUser);
              },
            });
          }
        }
      },
    });
  }

  

//   RefPointAndDateTimeByTrainId(trainId: number) {
//     this.loading = true;
//     this.loadingMsg = 'Loading reference point and datetime...';
//     this.noYearMessage = '';
//     // this.showRefpointList = false;

//     this.trainService.getRefPointAndDateTimeByTrainId(trainId).subscribe({
//       next: (data) => {
//         this.loading = false;
//         this.loadingMsg = '';

//         if (!data) {
//           this.noYearMessage = 'No reference point data available for this train. You can still pick any date.';
//           return;
//         }

//         try {
//           const apiDate = new Date(data.DateTime);
//           if (isNaN(apiDate.getTime())) {
//             console.warn('Invalid DateTime from API:', data.DateTime);
//             this.noYearMessage = 'Invalid date format received from server.';
//             return;
//           }

//           this.trainrefpointdatetime.RefPoint = data.RefPoint;
//           const [datePart, timePart] = data.DateTime.split(' ');

//           // Patch default date & time
//           this.operationForm.patchValue({
//             datetime: new Date(datePart),
//             time: timePart || ''
//           });

//           // this.showRefpointList = true;

//           // Load allowed months/days for the API date
//           const year = apiDate.getFullYear();
//           const month = apiDate.getMonth() + 1;
//           const day = apiDate.getDate();

//           this.trainService.getMonthsByTrainIdAndYear(trainId, year).subscribe({
//             next: (months) => {
//               this.allowedMonths = months || [];

//               if (this.allowedMonths.includes(month)) {
//                 this.trainService.getDaysByTrainYearMonth(trainId, year, month).subscribe({
//                   next: (days) => {
//                     this.allowedDays = days || [];

//                     this.trainService.getTimesByTrainYearMonthDay(trainId, year, month, day).subscribe({
//                       next: (times) => {
//                         this.timeList = times || [];

//                         // Keep API time selected if present
//                         if (timePart && this.timeList.includes(timePart)) {
//                           this.operationForm.patchValue({ time: timePart });
//                         }
//                       },
//                       error: () => this.timeList = []
//                     });
//                   },
//                   error: () => this.allowedDays = []
//                 });
//               }
//             },
//             error: () => this.allowedMonths = []
//           });

//         } catch (error) {
//           console.error('Error processing RefPointAndDateTime:', error);
//           this.noYearMessage = 'Error processing date/time data from server.';
//         }
//       },
//       error: (err) => {
//         this.loading = false;
//         this.loadingMsg = '';
//         this.noYearMessage = 'Error loading reference point data. You can still pick any date.';
//         console.error('Error fetching reference point and datetime:', err);
//       }
//     });
//   }

//   preloadYears(trainId: number) {
//     this.loading = true;
//     this.loadingMsg = 'Loading available years...';
//     this.noYearMessage = '';

//     this.trainService.getYearsByTrainId(trainId).subscribe({
//       next: (data: number[]) => {
//         this.years = data || [];
//         if(this.years.length > 0){
//           this.showRefpointList = true;
//         }
//         this.loading = false;
//         this.loadingMsg = '';
//       },
//       error: () => {
//         this.years = [];
//         this.loading = false;
//         this.loadingMsg = '';
//       }
//     });
//   }

//   chosenYearHandler(normalizedYear: Date) {
//     const year = normalizedYear.getFullYear();
//     this.operationForm.patchValue({ datetime: new Date(year, 0, 1), time: '' });

//     this.datepickerLoading = true;
//     this.trainService.getMonthsByTrainIdAndYear(this.trainIdCal, year).subscribe({
//       next: (data: number[]) => {
//         this.allowedMonths = data || [];
//         this.allowedDays = [];
//         this.timeList = [];
//         this.datepickerLoading = false;

//         if (this.allowedMonths.length > 0) {
//           const firstMonth = this.allowedMonths[0] - 1;
//           this.operationForm.patchValue({ datetime: new Date(year, firstMonth, 1) });
//           this.picker.close();
//           setTimeout(() => { this.picker.startView = 'year'; this.picker.open(); }, 150);
//         }
//       },
//       error: () => {
//         this.allowedMonths = [];
//         this.allowedDays = [];
//         this.timeList = [];
//         this.datepickerLoading = false;
//       }
//     });
//   }

//   chosenMonthHandler(normalizedMonth: Date) {
//     const year = normalizedMonth.getFullYear();
//     const month = normalizedMonth.getMonth() + 1;
//     this.operationForm.patchValue({ datetime: new Date(year, month - 1, 1), time: '' });

//     this.datepickerLoading = true;
//     this.trainService.getDaysByTrainYearMonth(this.trainIdCal, year, month).subscribe({
//       next: (data: number[]) => {
//         this.allowedDays = data || [];
//         this.timeList = [];
//         this.datepickerLoading = false;

//         if (this.allowedDays.length > 0) {
//           const newDate = new Date(year, month - 1, this.allowedDays[0]);
//           this.operationForm.patchValue({ datetime: newDate });

//           if (this.allowedDays.length === 1) {
//             this.handleSingleDaySelected(newDate);
//           }else {
//               // 👇 manually trigger same logic as dateSelected
//               this.dateSelected({ value: newDate });
//             }

//           this.picker.close();
//           setTimeout(() => { this.picker.startView = 'month'; this.picker.open(); }, 150);
//         }
//       },
//       error: () => { this.allowedDays = []; this.timeList = []; this.datepickerLoading = false; }
//     });
//   }

//   handleSingleDaySelected(selected: Date) {
//     const year = selected.getFullYear();
//     const month = selected.getMonth() + 1;
//     const day = selected.getDate();
//     this.trainService.getTimesByTrainYearMonthDay(this.trainIdCal, year, month, day).subscribe({
//       next: (data: string[]) => { this.timeList = data || []; },
//       error: () => { this.timeList = []; }
//     });
//   }

//   dateSelected(event: any) {
//     const selected: Date | null = event?.value;
//     if (!selected) return;
//     const year = selected.getFullYear();
//     const month = selected.getMonth() + 1;
//     const day = selected.getDate();

//     this.operationForm.patchValue({ datetime: selected, time: '' });

//     this.trainService.getTimesByTrainYearMonthDay(this.trainIdCal, year, month, day).subscribe({
//       next: (data: string[]) => { this.timeList = data || []; },
//       error: () => { this.timeList = []; }
//     });
//   }

// onTimeChange(event: Event) {
//   const selectedTime = (event.target as HTMLSelectElement).value;
//   const selectedDate: Date = this.operationForm.get('datetime')?.value;
//   if (!selectedDate || !selectedTime) return;

//   const [hours, minutes, seconds] = selectedTime.split(':').map(x => parseInt(x, 10));
//   const dateObj = new Date(
//     selectedDate.getFullYear(),
//     selectedDate.getMonth(),
//     selectedDate.getDate(),
//     hours,
//     minutes,
//     seconds || 0
//   );

//   // Format as string: "YYYY-MM-DD HH:mm:ss"
//   const pad = (n: number) => n.toString().padStart(2, '0');
//   const dateStr = `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;

//   // this.RefPointDateTime = dateStr;
//    this.RefPointDateTime = { trainId: this.trainIdCal, datetime: dateStr }
  
//      this.trainService.getRefPointIdsByDatetimeString(dateStr, this.trainIdCal).subscribe({
//     next: (refPointIds: number[]) => {
//       console.log('RefPoint IDs from API:', refPointIds);

//       // Optionally, you can auto-select the first ref point ID
//       if (refPointIds.length > 0) {
//         this.trainrefpointdatetime.RefPoint = refPointIds[0];
//         console.log('Selected RefPoint:', this.trainrefpointdatetime.RefPoint);
//       }
//     },
//     error: (err) => {
//       console.error('Error fetching ref point IDs:', err);
//     }
//   });
//   console.log('RefPointDateTime:', this.RefPointDateTime);
// }

//   dateFilter = (d: Date | null): boolean => {
//     if (!d) return false;
//     const y = d.getFullYear(), m = d.getMonth() + 1, day = d.getDate();
//     if (this.years.length && !this.years.includes(y)) return false;
//     if (this.allowedMonths.length && !this.allowedMonths.includes(m)) return false;
//     if (this.allowedDays.length && !this.allowedDays.includes(day)) return false;
//     return true;
//   };

//   resetAll() {
//     this.operationForm.patchValue({ datetime: '', time: '' });
//     this.years = [];
//     this.allowedMonths = [];
//     this.allowedDays = [];
//     this.timeList = [];
//     this.noYearMessage = '';
//   }
onTimeChangeManual(time: string) {
  this.operationForm.patchValue({ time });
  
  // Also trigger the same logic as onTimeChange for consistency
  const datetimeVal = this.operationForm.get('datetime')?.value;
  
  if (!datetimeVal || !time) return;

  const currentDate = new Date(datetimeVal);
  if (isNaN(currentDate.getTime())) {
    console.error('Invalid datetime value:', datetimeVal);
    return;
  }

  const [hours, minutes, seconds] = time.split(':').map(x => parseInt(x, 10));
  currentDate.setHours(hours, minutes, seconds || 0);

  const pad = (n: number) => n.toString().padStart(2, '0');
  const dateStr = `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(currentDate.getDate())} ${pad(currentDate.getHours())}:${pad(currentDate.getMinutes())}:${pad(currentDate.getSeconds())}`;

  const dateObj = new Date(
    datetimeVal.getFullYear(),
    datetimeVal.getMonth(),
    datetimeVal.getDate(),
    hours,
    minutes,
    seconds || 0
  );
  
  this.operationForm.patchValue({
    datetime: dateObj,
    time: time
  });

  // Update display with custom format
  this.updateDateTimeDisplay();

  this.RefPointDateTime = { trainId: this.trainIdCal, datetime: dateStr };

  this.trainService.getRefPointIdsByDatetimeString(dateStr, this.trainIdCal).subscribe({
    next: (refPointIds: number[]) => {
      console.log('RefPoint IDs from API:', refPointIds);
      if (refPointIds.length > 0) {
        this.trainrefpointdatetime.RefPoint = refPointIds[0];
        console.log('Selected RefPoint:', this.trainrefpointdatetime.RefPoint);
      }
    },
    error: (err) => {
      console.error('Error fetching ref point IDs:', err);
    }
  });

  console.log('RefPointDateTime:', this.RefPointDateTime);
  
  // Close the datepicker when time is selected
  this.picker.close();
}

ngAfterViewInit() {
  this.picker.openedStream.subscribe(() => {
    setTimeout(() => {
      const calendarContent = document.querySelector('.mat-datepicker-content');
      if (calendarContent && !calendarContent.querySelector('.time-panel')) {
        const panel = document.createElement('div');
        panel.classList.add('time-panel');

        let list = '<ul>';
        this.timeList.forEach((t: string) => {
          const currentSelectedTime = this.operationForm.get('time')?.value;
          const isActive = currentSelectedTime === t ? 'active' : '';
          list += `<li class="${isActive}" onclick="document.dispatchEvent(new CustomEvent('timeSelect',{detail:'${t}'}))">${t}</li>`;
        });
        list += '</ul>';

        panel.innerHTML = list;
        calendarContent.appendChild(panel);
        
        // Auto-scroll to selected time if any
        setTimeout(() => {
          const activeItem = panel.querySelector('.active');
          if (activeItem) {
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
      }
    }, 0);
  });

  // Listen for custom event
  document.addEventListener('timeSelect', (e: any) => {
    console.log('Time selected from panel:', e.detail);
    this.onTimeChangeManual(e.detail);
    
    // Update the visual selection in the time panel
    setTimeout(() => {
      const allTimeItems = document.querySelectorAll('.time-panel li');
      allTimeItems.forEach(item => item.classList.remove('active'));
      
      const selectedItem = Array.from(allTimeItems).find(item => 
        item.textContent?.trim() === e.detail
      );
      if (selectedItem) {
        selectedItem.classList.add('active');
      }
    }, 50);
  });
}

cancelDateSelection() {
  this.picker.close();
}

confirmDateTimeSelection() {
  this.picker.close();
}

RefPointAndDateTimeByTrainId(trainId: number) {
  this.loading = true;
  this.loadingMsg = 'Loading reference point and datetime...';
  this.noYearMessage = '';

  this.trainService.getRefPointAndDateTimeByTrainId(trainId).subscribe({
    next: (data) => {
      this.loading = false;
      this.loadingMsg = '';

      if (!data) {
        this.noYearMessage = 'No reference point data available for this train. You can still pick any date.';
        return;
      }

      try {
        const apiDate = new Date(data.DateTime);
        if (isNaN(apiDate.getTime())) {
          console.warn('Invalid DateTime from API:', data.DateTime);
          this.noYearMessage = 'Invalid date format received from server.';
          return;
        }

        this.trainrefpointdatetime.RefPoint = data.RefPoint;
        const [datePart, timePart] = data.DateTime.split(' ');

        this.operationForm.patchValue({
          datetime: new Date(datePart),
          time: timePart || ''
        });

        // Update display after setting values
        setTimeout(() => this.updateDateTimeDisplay(), 0);

        const year = apiDate.getFullYear();
        const month = apiDate.getMonth() + 1;
        const day = apiDate.getDate();

        this.trainService.getMonthsByTrainIdAndYear(trainId, year).subscribe({
          next: (months) => {
            this.allowedMonths = months || [];

            if (this.allowedMonths.includes(month)) {
              this.trainService.getDaysByTrainYearMonth(trainId, year, month).subscribe({
                next: (days) => {
                  this.allowedDays = days || [];

                  this.trainService.getTimesByTrainYearMonthDay(trainId, year, month, day).subscribe({
                    next: (times) => {
                      this.timeList = times || [];

                      if (timePart && this.timeList.includes(timePart)) {
                        this.operationForm.patchValue({ time: timePart });
                        setTimeout(() => this.updateDateTimeDisplay(), 0);
                      }
                    },
                    error: () => this.timeList = []
                  });
                },
                error: () => this.allowedDays = []
              });
            }
          },
          error: () => this.allowedMonths = []
        });

      } catch (error) {
        console.error('Error processing RefPointAndDateTime:', error);
        this.noYearMessage = 'Error processing date/time data from server.';
      }
    },
    error: (err) => {
      this.loading = false;
      this.loadingMsg = '';
      this.noYearMessage = 'Error loading reference point data. You can still pick any date.';
      console.error('Error fetching reference point and datetime:', err);
    }
  });
}

preloadYears(trainId: number) {
  this.loading = true;
  this.loadingMsg = 'Loading available years...';
  this.noYearMessage = '';

  this.trainService.getYearsByTrainId(trainId).subscribe({
    next: (data: number[]) => {
      this.years = data || [];
      if(this.years.length > 0){
        this.showRefpointList = true;
      }
      this.loading = false;
      this.loadingMsg = '';
    },
    error: () => {
      this.years = [];
      this.loading = false;
      this.loadingMsg = '';
    }
  });
}

chosenYearHandler(normalizedYear: Date) {
  const year = normalizedYear.getFullYear();
  this.operationForm.patchValue({ datetime: new Date(year, 0, 1), time: '' });

  this.datepickerLoading = true;
  this.trainService.getMonthsByTrainIdAndYear(this.trainIdCal, year).subscribe({
    next: (data: number[]) => {
      this.allowedMonths = data || [];
      this.allowedDays = [];
      this.timeList = [];
      this.datepickerLoading = false;

      if (this.allowedMonths.length > 0) {
        const firstMonth = this.allowedMonths[0] - 1;
        this.operationForm.patchValue({ datetime: new Date(year, firstMonth, 1) });
        this.updateDateTimeDisplay();
        // Keep datepicker open and change view to year
        this.picker.close();
        setTimeout(() => { 
          this.picker.startView = 'year'; 
          if (!this.picker.opened) {
            this.picker.open(); 
          }
        }, 150);
      }
    },
    error: () => {
      this.allowedMonths = [];
      this.allowedDays = [];
      this.timeList = [];
      this.datepickerLoading = false;
    }
  });
}

chosenMonthHandler(normalizedMonth: Date) {
  const year = normalizedMonth.getFullYear();
  const month = normalizedMonth.getMonth() + 1;
  this.operationForm.patchValue({ datetime: new Date(year, month - 1, 1), time: '' });

  this.datepickerLoading = true;
  this.trainService.getDaysByTrainYearMonth(this.trainIdCal, year, month).subscribe({
    next: (data: number[]) => {
      this.allowedDays = data || [];
      this.timeList = [];
      this.datepickerLoading = false;

      if (this.allowedDays.length > 0) {
        const newDate = new Date(year, month - 1, this.allowedDays[0]);
        this.operationForm.patchValue({ datetime: newDate });
        this.updateDateTimeDisplay();

        if (this.allowedDays.length === 1) {
          this.handleSingleDaySelected(newDate);
        } else {
          this.dateSelected({ value: newDate });
        }

        this.picker.close(); 
        // Keep datepicker open and change view to month
        setTimeout(() => { 
          this.picker.startView = 'month'; 
          if (!this.picker.opened) {
            this.picker.open(); 
          }
        }, 150);
      }
    },
    error: () => { 
      this.allowedDays = []; 
      this.timeList = []; 
      this.datepickerLoading = false; 
    }
  });
}

handleSingleDaySelected(selected: Date) {
  const year = selected.getFullYear();
  const month = selected.getMonth() + 1;
  const day = selected.getDate();
  this.trainService.getTimesByTrainYearMonthDay(this.trainIdCal, year, month, day).subscribe({
    next: (data: string[]) => { 
      this.timeList = data || []; 
      this.updateDateTimeDisplay();
      // Keep datepicker open to show time panel
      if (!this.picker.opened) {
        setTimeout(() => this.picker.open(), 100);
      }
    },
    error: () => { this.timeList = []; }
  });
}

dateSelected(event: any) {
  const selected: Date | null = event?.value;
  if (!selected) return;
  
  const year = selected.getFullYear();
  const month = selected.getMonth() + 1;
  const day = selected.getDate();

  this.operationForm.patchValue({ datetime: selected, time: '' });
  this.updateDateTimeDisplay();

  this.trainService.getTimesByTrainYearMonthDay(this.trainIdCal, year, month, day).subscribe({
    next: (data: string[]) => { 
      this.timeList = data || [];
      this.updateDateTimeDisplay();
      
      // Keep datepicker open after day selection to show time panel
      if (this.picker.opened) {
        // Force refresh the time panel
        setTimeout(() => {
          const calendarContent = document.querySelector('.mat-datepicker-content');
          const existingPanel = calendarContent?.querySelector('.time-panel');
          if (existingPanel) {
            existingPanel.remove();
          }
          
          // Re-create the time panel with new times
          if (calendarContent && this.timeList.length > 0) {
            const panel = document.createElement('div');
            panel.classList.add('time-panel');

            let list = '<ul>';
            this.timeList.forEach((t: string) => {
              const currentSelectedTime = this.operationForm.get('time')?.value;
              const isActive = currentSelectedTime === t ? 'active' : '';
              list += `<li class="${isActive}" onclick="document.dispatchEvent(new CustomEvent('timeSelect',{detail:'${t}'}))">${t}</li>`;
            });
            list += '</ul>';

            panel.innerHTML = list;
            calendarContent.appendChild(panel);
          }
        }, 100);
      } else {
        // If picker is closed, reopen it to show time selection
        setTimeout(() => this.picker.open(), 100);
      }
    },
    error: () => { 
      this.timeList = []; 
    }
  });
}

onTimeChange(event: Event) {
  const selectedTime = (event.target as HTMLSelectElement).value;
  const datetimeVal = this.operationForm.get('datetime')?.value;

  if (!datetimeVal || !selectedTime) return;

  // Handle both Date object and string values
  let currentDate: Date;
  if (typeof datetimeVal === 'string') {
    // If it's already a string with date + time, extract just the date part
    const dateOnly = datetimeVal.split(' ')[0];
    currentDate = new Date(dateOnly);
  } else {
    currentDate = new Date(datetimeVal);
  }

  if (isNaN(currentDate.getTime())) {
    console.error('Invalid datetime value:', datetimeVal);
    return;
  }

  const [hours, minutes, seconds] = selectedTime.split(':').map(x => parseInt(x, 10));
  currentDate.setHours(hours, minutes, seconds || 0);

  const pad = (n: number) => n.toString().padStart(2, '0');
  const dateStr = `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(currentDate.getDate())} ${pad(currentDate.getHours())}:${pad(currentDate.getMinutes())}:${pad(currentDate.getSeconds())}`;

  // Create a proper Date object for the form
  const dateObj = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    hours,
    minutes,
    seconds || 0
  );
  
  this.operationForm.patchValue({
    datetime: dateObj,
    time: selectedTime
  });

  // Update display with custom format
  this.updateDateTimeDisplay();

  this.RefPointDateTime = { trainId: this.trainIdCal, datetime: dateStr };

  this.trainService.getRefPointIdsByDatetimeString(dateStr, this.trainIdCal).subscribe({
    next: (refPointIds: number[]) => {
      console.log('RefPoint IDs from API:', refPointIds);
      if (refPointIds.length > 0) {
        this.trainrefpointdatetime.RefPoint = refPointIds[0];
        console.log('Selected RefPoint:', this.trainrefpointdatetime.RefPoint);
      }
    },
    error: (err) => {
      console.error('Error fetching ref point IDs:', err);
    }
  });

  console.log('RefPointDateTime:', this.RefPointDateTime);
  
  // Close the datepicker when time is selected from dropdown
  this.picker.close();
}

// Updated method to format datetime as M/d/yyyy HH:mm:ss
updateDateTimeDisplay() {
  const datetimeVal = this.operationForm.get('datetime')?.value;
  const timeVal = this.operationForm.get('time')?.value;
  
  if (datetimeVal) {
    let displayValue = '';
    
    // Handle both Date objects and string values
    let dateObj: Date;
    if (typeof datetimeVal === 'string') {
      dateObj = new Date(datetimeVal.split(' ')[0]); // Extract date part if it's a string
    } else {
      dateObj = new Date(datetimeVal);
    }
    
    if (!isNaN(dateObj.getTime())) {
      // Format as M/d/yyyy (without leading zeros for month and day)
      const month = dateObj.getMonth() + 1;
      const day = dateObj.getDate();
      const year = dateObj.getFullYear();
      
      displayValue = `${month}/${day}/${year}`;
      
      if (timeVal) {
        displayValue += ` ${timeVal}`;
      }
      
      // Update the input display
      setTimeout(() => {
        const inputElement = document.querySelector('input[formControlName="datetime"]') as HTMLInputElement;
        if (inputElement) {
          inputElement.value = displayValue;
        }
      }, 0);
    }
  }
}

dateFilter = (d: Date | null): boolean => {
  if (!d) return false;
  const y = d.getFullYear(), m = d.getMonth() + 1, day = d.getDate();
  if (this.years.length && !this.years.includes(y)) return false;
  if (this.allowedMonths.length && !this.allowedMonths.includes(m)) return false;
  if (this.allowedDays.length && !this.allowedDays.includes(day)) return false;
  return true;
};

resetAll() {
  this.operationForm.patchValue({ datetime: '', time: '' });
  this.years = [];
  this.allowedMonths = [];
  this.allowedDays = [];
  this.timeList = [];
  this.noYearMessage = '';
  
  // Clear the input display
  setTimeout(() => {
    const inputElement = document.querySelector('input[formControlName="datetime"]') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
  }, 0);
}
  compareFn(a: any, b: any): boolean {
    return a.Id === b.Id; // Compare based on the "Id" property
  }

  selecteduser(event) {
    console.log(this.selectedUser);
  }

  /* sendtoopdata() {
    var id = btoa(this.trainDetails.Id.toString());
    this.router.navigate(['/trains/edit/' + id + '/opdata'], {
      queryParams: {
        showselector: true,
        PlantId: btoa(this.trainDetails.PlantId.toString()),
        trainId: btoa(this.trainDetails.Id.toString()),
      },
    });
  }

  sendToPrimaryG() {
    // var plantId =btoa(this.plantName.toString());
    var id = btoa(this.trainDetails.Id.toString());
    this.router.navigate(['/component/trains/edit/' + id]);
    this.router.navigate(['/component/trains/edit/' + id + '/primarygraph'], {
      queryParams: {
        showselector: true,
        trainId: btoa(this.trainDetails.Id.toString()),
        plantId: btoa(this.trainDetails.PlantId.toString()),
        plantName: btoa(this.plantName),
      },
    });
  }

  sendToWarrantiesG() {
    var id = btoa(this.trainDetails.Id.toString());
    this.router.navigate(['/component/trains/edit/' + id]);
    this.router.navigate(
      ['/component/trains/edit/' + id + '/warrantiesgraph'],
      {
        queryParams: {
          trainId: btoa(this.trainDetails.Id.toString()),
          plantId: btoa(this.trainDetails.PlantId.toString()),
          plantName: btoa(this.plantName.toString()),
        },
      }
    );
  }

  sendToCustomG() {
    var id = btoa(this.trainDetails.Id.toString());
    this.router.navigate(['/component/trains/edit/' + id]);
    this.router.navigate(['/component/trains/edit/' + id + '/customgraph'], {
      queryParams: {
        showselector: true,
        selections: false,
        trainId: btoa(this.trainDetails.Id.toString()),
        plantId: btoa(this.trainDetails.PlantId.toString()),
        plantName: btoa(this.plantName.toString()),
      },
    });
  } */

  getFilteredUsers(comanyUsers: User[], selectedUser: User[]): User[] {
    return comanyUsers.filter(
      (user) =>
        !selectedUser.some((selectedUser) => selectedUser.Id === user.Id)
    );
  }

  sendtowarrenty() {
    var id = btoa(this.trainDetails.Id.toString());
    this.router.navigate(['/component/trains/edit/' + id + '/warrantycondition']);
  }

  openModal(template: TemplateRef<any>) {
    this.modalService.open(template, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  close() {
    this.modalService.dismissAll();
  }

  showemployee(content) {
    this.modalReference = this.modalService.open(content);
  }

  updatetrain() {
    this.userLister = this.getFilteredUsers(
      this.comanyUsers,
      this.selectedUser
    );
    console.log(this.userLister);

    const dateNowISO = this.dateNow.toISOString();
    this.trainDetails.UpdatedAt = new Date(dateNowISO);
    this.trainDetails.UserId = 0;
    this.trainDetails.AspNetUsersId = this.CurrentUserId;

    let trainobj = new TrainViewmodel();
    trainobj.traindata = this.trainDetails;

    if (this.trainDetails.AccessOption == 1) {
      this.selectedUser.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = false;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
      this.userLister.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = true;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
    } else if (this.trainDetails.AccessOption == 0) {
      this.selectedUser.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = true;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
      this.userLister.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 1;
        this.addTrainUsers.AccessFlag = false;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
    }
    // this.trainDetails.RefPoint = this.RefPointDateTime;// added on 25th Nov 2024
 const oldtrianrefpoint = this.trainDetails.RefPoint;
  this.trainDetails.RefPoint = this.trainrefpointdatetime.RefPoint;
   this.trainobj.traindata.RefPoint = this.trainDetails.RefPoint; 
    // this.trainobj.traindata.RefPoint = this.RefPointDateTime;
    
    trainobj.traindata = this.trainDetails;
    if (this.ExistingRefPoint != this.trainDetails.RefPoint) {
    // if (this.ExistingRefPoint != this.RefPointDateTime) {
      this.refPointUpdated = true;
    }

    this.trainDetails.UpdatedAt = new Date(dateNowISO);
    console.log(trainobj);
    this.trainService.updateTrain(trainobj).subscribe({
      next: (response) => {
        if(oldtrianrefpoint != this.trainDetails.RefPoint){
        if (this.refPointUpdated) {
          this.opdataservice
            .RecalcOpdataForNewRefPoint(this.trainDetails.Id.toString())
            .subscribe({
              next: (response) => {},
            });
        }
        this.toastr.success('Train Updated Successfully.', 'Information');
        console.log(trainobj);
      }
      else{
        this.toastr.success('Train Updated Successfully.', 'Information');
      }
      },
    });
    console.log(this.trainDetails);
  }

  deleteTrain(id: number) {
    this.DelTrainId = id + '';
    const confirmDelete = confirm(
      'Are you sure you want to delete this Train?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }
    this.trainService
      .deleteTrain(this.DelTrainId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.error('Train deleted successfully.', 'Information');
          this.router.navigate(['/component/trains']);
        } else {
          (error) => {
            console.log('Error deleting Train:', error);
          };
        }
      });
  }

  duplicateTrain() {
    //this.DelTrainId = id + '';
    const confirmDuplicate = confirm(
      'Are you sure you want to duplicate this Train?'
    );

    if (!confirmDuplicate) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }
    this.addTrain();
  }

  addTrain() {
    this.userLister = this.getFilteredUsers(
      this.comanyUsers,
      this.selectedUser
    );
    console.log(this.userLister);
    const dateNowISO = this.dateNow.toISOString();
    this.trainDetails.Name = this.trainDetails.Name + '-copy';
    this.trainDetails.CreatedAt = new Date(dateNowISO);
    this.trainDetails.UpdatedAt = new Date(dateNowISO);
    this.trainDetails.UserId = 0;
    this.trainDetails.AspNetUsersId = this.CurrentUserId;

    let trainobj = new TrainViewmodel();
    trainobj.traindata = this.trainDetails;

    if (this.trainDetails.AccessOption == 1) {
      this.selectedUser.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = this.CurrentUserId;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = false;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
      this.userLister.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = true;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
    } else if (this.trainDetails.AccessOption == 0) {
      this.selectedUser.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 0;
        this.addTrainUsers.AccessFlag = true;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
      this.userLister.forEach((element) => {
        this.addTrainUsers = new TrainUsers();
        this.addTrainUsers.TrainId = this.trainDetails.Id;
        this.addTrainUsers.AspNetUsersId = element.Id;
        this.addTrainUsers.UserId = +element.UserId;
        this.addTrainUsers.IsAdmin = 1;
        this.addTrainUsers.AccessFlag = false;
        this.addTrainUsers.CreatedAt = new Date(dateNowISO);
        this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
        trainobj.trainuser.push(this.addTrainUsers);
      });
    }
    trainobj.traindata = this.trainDetails;
    console.log(this.trainDetails)
    if (this.ExistingRefPoint != this.trainDetails.RefPoint) {
      this.refPointUpdated = true;
    }

    this.trainDetails.UpdatedAt = new Date(dateNowISO);
    console.log(trainobj);
    this.trainService.addTrain(trainobj).subscribe({
      next: (response) => {
        if (this.refPointUpdated) {
          this.opdataservice
            .RecalcOpdataForNewRefPoint(this.trainDetails.Id.toString())
            .subscribe({
              next: (response) => {},
            });
        }
        this.toastr.success('Train Duplicated Successfully.', 'Information');
        console.log(trainobj);
      },
    });
    console.log(this.trainDetails);
  }



  //Below functions added new for navigation changes


   sendtoopdata() {
  var id = btoa(this.trainDetails.Id.toString());

   //  plant id stored service 
  this.plantService.setSelectedPlant(this.trainDetails.PlantId);
     // train id stored service 
  this.plantService.setSelectedTrain(this.trainDetails.Id);
  
  this.router.navigate(
    ['/component/trains/edit/' + id + '/opdata'],
    {
      state: {
        showselector: true,
        PlantId: this.trainDetails.PlantId.toString(),
        trainId: this.trainDetails.Id.toString()
      }
    }
  );
}
 
  
 
sendToPrimaryG() {
  var id = btoa(this.trainDetails.Id.toString());
 
  this.router.navigate(
    ['/component/trains/edit/' + id + '/primarygraph'],
    {
      state: {
        showselector: true,
        trainId: this.trainDetails.Id.toString(),
        plantId: this.trainDetails.PlantId.toString(),
        plantName: this.plantName
      }
    }
  );
}
 
 
 
  sendToWarrantiesG() {
  var id = btoa(this.trainDetails.Id.toString());
 
  this.router.navigate(
    ['/component/trains/edit/' + id + '/warrantiesgraph'],
    {
      state: {
        trainId: this.trainDetails.Id.toString(),
        plantId: this.trainDetails.PlantId.toString(),
        plantName: this.plantName.toString(),
        // Add warrantyId if needed
        warrantyId: this.warrantyId
      }
    }
  );
}
 
sendToCustomG(){
  var id = btoa(this.trainDetails.Id.toString());
  this.router.navigate(
    ['/component/trains/edit/'+ id + '/customgraph'],
    {
      state:{
        showselector : true,
        selections : false,
        trainId:this.trainDetails.Id.toString(),
         plantId: this.trainDetails.PlantId.toString(),
        plantName: this.plantName.toString()
      }
    }
  )
}
 
}
